import {
  FetchInAppNotificationsRequest,
  InAppNotificationPage,
  inAppNotificationsService,
} from '@aslanpay/portal-common-lib';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const useFetchInAppNotifications = (
  params: FetchInAppNotificationsRequest | undefined,
  enabled = true
) =>
  useQuery<InAppNotificationPage, Error>({
    queryKey: ['fetchInAppNotifications', params],
    queryFn: () => {
      if (!params) throw new Error('notification query parameters are required');
      return inAppNotificationsService.fetchInAppNotifications(params);
    },
    enabled: enabled && !!params?.individualId,
    refetchInterval: 60_000,
  });

const useMarkInAppNotificationAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (notificationId: string) =>
      inAppNotificationsService.markInAppNotificationAsRead(notificationId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['fetchInAppNotifications'] }),
  });
};

const useMarkAllInAppNotificationsAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (individualId: string) =>
      inAppNotificationsService.markAllInAppNotificationsAsRead(individualId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['fetchInAppNotifications'] }),
  });
};

const useInAppNotifications = {
  useFetchInAppNotifications,
  useMarkInAppNotificationAsRead,
  useMarkAllInAppNotificationsAsRead,
};

export default useInAppNotifications;
